<template>
  <section class="legal-page">
    <div class="legal-shell">
      <aside class="legal-intro">
        <p class="eyebrow">The fine print, plainly</p>
        <h1>Privacy<br>Policy</h1>
        <p class="updated">Last updated August 28, 2026</p>
      </aside>

      <div class="legal-content">
        <section>
          <span>01</span>
          <h2>Who operates this site</h2>
          <p>
            AliTutor is operated by Ali Khalil as a sole proprietorship. This
            policy explains how information is handled when you visit this site,
            schedule a consultation, or contact AliTutor.
          </p>
        </section>

        <section>
          <span>02</span>
          <h2>Information you choose to provide</h2>
          <p>
            When you prepare a booking request, the details stay in your browser
            until you choose to send the email through your own mail provider.
            AliTutor receives the name, reply address, course, availability, and
            tutoring details included in the email you send.
          </p>
        </section>

        <section>
          <span>03</span>
          <h2>How information is used</h2>
          <p>
            Information is used to arrange consultations, provide tutoring,
            respond to questions, manage scheduling, and send service-related
            follow-up. AliTutor does not sell your personal information.
          </p>
        </section>

        <section>
          <span>04</span>
          <h2>Email and service providers</h2>
          <p>
            Booking requests are sent through the mail provider you choose to
            use. Your provider handles that message under its own privacy
            practices. The website does not store a separate copy of the form.
          </p>
        </section>

        <section>
          <span>05</span>
          <h2>Retention and your choices</h2>
          <p>
            Information is kept only as long as reasonably necessary for
            scheduling, tutoring, recordkeeping, or legal obligations. You may
            ask to review or delete information you submitted by emailing
            <a href="mailto:alifortutoring@gmail.com">alifortutoring@gmail.com</a>.
          </p>
        </section>

        <router-link class="legal-cta" to="/contact">
          Book a free consultation <span aria-hidden="true">↗</span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.legal-page {
  padding: clamp(6rem, 11vw, 10rem) 1.5rem;
  background: var(--paper);
  color: var(--ink);
}

.legal-shell {
  display: grid;
  grid-template-columns: 0.7fr 1.3fr;
  gap: clamp(3rem, 9vw, 9rem);
  width: min(1120px, 100%);
  margin: 0 auto;
}

.legal-intro {
  position: sticky;
  top: 130px;
  align-self: start;
}

.eyebrow {
  margin: 0 0 1.2rem;
  color: var(--blue);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

h1 {
  margin: 0;
  font-size: clamp(3.5rem, 7vw, 6.5rem);
  letter-spacing: -0.07em;
  line-height: 0.85;
}

.updated {
  margin: 1.8rem 0 0;
  color: #707889;
  font-size: 0.88rem;
}

.legal-content {
  border-top: 1px solid #d7dce6;
}

.legal-content section {
  position: relative;
  padding: 2.5rem 0 2.8rem 4rem;
  border-bottom: 1px solid #d7dce6;
}

.legal-content section > span {
  position: absolute;
  top: 2.9rem;
  left: 0;
  color: var(--blue);
  font-size: 0.72rem;
  font-weight: 800;
}

h2 {
  margin: 0 0 0.9rem;
  font-size: 1.45rem;
  letter-spacing: -0.035em;
}

.legal-content p {
  margin: 0;
  color: #515968;
  line-height: 1.8;
}

.legal-content a:not(.legal-cta) {
  color: var(--blue);
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.legal-cta {
  display: inline-flex;
  gap: 0.8rem;
  margin-top: 2.5rem;
  padding: 1rem 1.2rem;
  border-radius: 999px;
  background: var(--ink);
  color: white;
  font-weight: 800;
  transition: transform 180ms ease, background 180ms ease;
}

.legal-cta:hover {
  background: var(--blue);
  transform: translateY(-2px);
}

@media (max-width: 760px) {
  .legal-shell {
    grid-template-columns: 1fr;
  }

  .legal-intro {
    position: static;
  }

  .legal-content section {
    padding-left: 2.5rem;
  }
}
</style>
